export namespace browserShellApi {
  // the "async" is here as the function must return Promise<void>
  export const openExternal = async (url: string) => {
    window.open(url, '_blank');
  };
}
